module.exports = __webpack_public_path__ + "img/bg.036ff32a.jpg";